import { Component } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-app-header',
  imports: [MatButtonModule, MatRippleModule],
  templateUrl: './app-header.component.html',
  styleUrl: './app-header.component.scss',
  standalone: true,
})
export class AppHeaderComponent {}
